import type { AuthClient } from "@stenpro/auth";
import {
  buildAuthHeadersForClient,
  HEADER_ORGANIZATION_ID,
  HEADER_TENANT_ID,
} from "@stenpro/auth";
import {
  DEFAULT_COMPANY,
  DEFAULT_ORGANIZATION,
  DEFAULT_TENANT,
} from "./authConfig";

let authClient: AuthClient | undefined;

export function registerAuthClient(client: AuthClient) {
  authClient = client;
}

export async function buildAuthHeaders(
  additional?: HeadersInit,
): Promise<Record<string, string>> {
  const headers = await buildAuthHeadersForClient(
    authClient,
    {
      tenantId: DEFAULT_TENANT,
      organizationId: DEFAULT_ORGANIZATION,
      companyId: DEFAULT_COMPANY,
    },
    additional,
  );

  const normalizeValue = (value?: string | null) => {
    const trimmed = (value ?? "").trim();
    if (!trimmed) {
      return undefined;
    }
    const lower = trimmed.toLowerCase();
    if (lower === "undefined" || lower === "null") {
      return undefined;
    }
    return trimmed;
  };

  const state = authClient?.getState();
  const tenantId = normalizeValue(state?.tenantId ?? state?.user?.tenantId ?? DEFAULT_TENANT);
  const organizationId = normalizeValue(state?.user?.organizationId ?? DEFAULT_ORGANIZATION);

  const hasHeader = (key: string) =>
    Object.keys(headers).some((header) => header.toLowerCase() === key.toLowerCase());

  if (tenantId && !hasHeader(HEADER_TENANT_ID)) {
    headers[HEADER_TENANT_ID] = tenantId;
  }

  if (organizationId && !hasHeader(HEADER_ORGANIZATION_ID)) {
    headers[HEADER_ORGANIZATION_ID] = organizationId;
  }

  return headers;
}
